import {LoadingView} from "../../designSystem/components/LoadingView";
import {NoPermissionView} from "./NoPermissionView";

export const PermissionGuard = ({
  userToken,
  userPermissions,
  permissionKey,
  children,
}) => {
  if (!userToken) return <LoadingView />
  if (!userPermissions) return <NoPermissionView />;
  if (!(permissionKey in userPermissions)) return <NoPermissionView />;
  if (!userPermissions[permissionKey]) return <NoPermissionView />;
  return children;
};